import Repo from '../repos/Repo';

export default class SentenceRepo extends Repo{

    constructor($auth){
        super($auth, 'sentences');
        this.categories = '/categories/';
    }

    all(q = undefined){
        let url = 'users/' + this.resource  + "?include=categories.users";

        if(q !== undefined){
            url = url + "&q="+q;
        }
        return this.http.get(url).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    store(data){
        return super.store(data, "categories")
    }

    update(id, data){
        return super.update(id, data, "categories")
    }

    get(id){
        return super.get(id, "categories")
    }

    attachCategory(id, categoryId){
        return this.http.post(this.resource + "/" + id + this.categories + categoryId + "?include=categories").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    detachCategory(id, categoryId){
        return this.http.delete(this.resource + "/" + id + this.categories + categoryId + "?include=categories").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    search(data){
        return this.http.post(this.resource + "/search", data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }
}


// WEBPACK FOOTER //
// ./src/repos/SentenceRepo.js